var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeaded)?_c('section',{staticClass:"header"},[_c('header1')],1):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"id":"dzIframe","src":"https://241.scsjb.cn?from=wap","frameborder":"0"}})])
}]

export { render, staticRenderFns }